import { render, staticRenderFns } from "./RouteConfig.vue?vue&type=template&id=476a9409&scoped=true&"
import script from "./RouteConfig.vue?vue&type=script&lang=js&"
export * from "./RouteConfig.vue?vue&type=script&lang=js&"
import style0 from "./RouteConfig.vue?vue&type=style&index=0&id=476a9409&lang=scss&scoped=true&"
import style1 from "./RouteConfig.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476a9409",
  null
  
)

export default component.exports